import { createActionType } from "Common/namespaceUtils/namespaceRedux";
import { FULL_NAMESPACE } from "../constants";
export default {
    PREVIEW_IMPORT: createActionType(FULL_NAMESPACE, "PREVIEW_IMPORT"),
    SET_MODE_AND_DOCUMENT_ID: createActionType(FULL_NAMESPACE, "SET_MODE_AND_DOCUMENT_ID"),
    SET_DRAFT: createActionType(FULL_NAMESPACE, "SET_DRAFT"),
    GET_DOCUMENT: createActionType(FULL_NAMESPACE, "GET_DOCUMENT"),
    GET_DOCUMENT_COMPLETED: createActionType(FULL_NAMESPACE, "GET_DOCUMENT_COMPLETED"),
    SAVE_DOCUMENT: createActionType(FULL_NAMESPACE, "SAVE_DOCUMENT"),
    SAVE_DOCUMENT_COMPLETED: createActionType(FULL_NAMESPACE, "SAVE_DOCUMENT_COMPLETED"),
    GET_WORKSPACE_PROJECTS: createActionType(FULL_NAMESPACE, "GET_WORKSPACE_PROJECTS"),
    GET_WORKSPACE_PROJECTS_COMPLETED: createActionType(FULL_NAMESPACE, "GET_WORKSPACE_PROJECTS_COMPLETED"),
    DUPLICATE_DOCUMENT: createActionType(FULL_NAMESPACE, "DUPLICATE_DOCUMENT"),
    DUPLICATE_DOCUMENT_COMPLETED: createActionType(FULL_NAMESPACE, "DUPLICATE_DOCUMENT_COMPLETED")
};
